import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import _, { map } from "lodash"
import { Card, CardBody } from "reactstrap"
import UserDrawer from "./userDrawer"
import RoleDrawer from "./roleDrawer"
import { userFilters, roleFilters } from "../../constants/uiConstants"
import "react-datepicker/dist/react-datepicker.css"

const _getConstFilters = (type, props) => {
  switch (type) {
    case "user":
      return userFilters
    case "role":
      return roleFilters
    default:
      return props.allowedFilters
  }
}

const Chips = props => {
  const filterClass = props.showFilters ? "d-block" : "d-none"
  const constFilters = _getConstFilters(props.type, props)
  const _getDrawer = () => {
    switch (props.type) {
      case "user":
        return (
          <div>
            <UserDrawer
              filters={props.filters}
              handleFilterChange={props.handleFilterChange}
              currentUser={props.currentUser}
              toggleAdvancedFilters={props.toggleAdvancedFilters}
              showAdvancedFilters={props.showAdvancedFilters}
            />
          </div>
        )
      case "role":
        return (
          <div>
            <RoleDrawer
              filters={props.filters}
              handleFilterChange={props.handleFilterChange}
              currentUser={props.currentUser}
              toggleAdvancedFilters={props.toggleAdvancedFilters}
              showAdvancedFilters={props.showAdvancedFilters}
            />
          </div>
        )
      default:
        return props.drawer()
    }
  }

  let appliedFilters = 0
  return (
    <div className="filter-dropdown">
      <Card>
        <CardBody>
          <div
            className="d-flex align-items-center flex-wrap"
            onClick={e => {
              props.toggleFilters(!props.showFilters)
            }}
          >
            {Object.keys(constFilters).map(filter => {
              const filterValue = "" + props.filters[filter]
              if (
                filterValue !== "null" &&
                filterValue !== "undefined" &&
                filterValue !== ""
              ) {
                appliedFilters++
                const filterLable = constFilters[filter].valueMap
                  ? constFilters[filter].valueMap[props.filters[filter]]
                  : props.filters[filter]

                return (
                  <div
                    className="tag-item"
                    style={{ color: "black" }}
                    key={filter}
                    onClick={() => props.removeFilter(filter)}
                  >
                    {`${constFilters[filter].filterName}: ${filterLable}`}
                    <button
                      type="button"
                      className="button"
                      onClick={() => props.toggleFilters(false)}
                    >
                      &times;
                    </button>
                  </div>
                )
              }
            })}
            <div
              className="tag-item add-more px-2"
              role="button"
              onClick={() => props.toggleFilters(!props.showFilters)}
            >
              <i className="fa fa-filter" />
              <div className="ms-2">More Filters</div>
              <button type="button" className="button font-size-14">
                {appliedFilters}
              </button>
            </div>
          </div>
        </CardBody>
        <div
          className={`filter-dropdown-content ${filterClass}`}
          style={{ background: "ghostwhite" }}
        >
          <div className="d-flex justify-content-end">
            <div
              onClick={() => props.search()}
              role="button"
              className="btn btn-success btn-sm mx-1 d-flex align-items-center"
            >
              <div className="mx-2">Apply</div>
              <span>
                <i className="bx bx-check-double font-size-16 align-middle me-2"></i>
              </span>
            </div>
          </div>
          {props.showFilters && _getDrawer()}
        </div>
      </Card>
    </div>
  )
}

Chips.propTypes = {
  drawer: PropTypes.func,
  search: PropTypes.func,
  toggleFilters: PropTypes.func,
  allowedFilters: PropTypes.object,
  filters: PropTypes.object,
}

function mapStateToProps(store) {
  return {
    currentUser: _.get(store, "currentUser.currentUser.data"),
  }
}

export default connect(mapStateToProps)(Chips)
